import { render, staticRenderFns } from "./gitlab.vue?vue&type=template&id=37d69650&"
import script from "./gitlab.vue?vue&type=script&lang=js&"
export * from "./gitlab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports